import { render, staticRenderFns } from "./OActiveButton.vue?vue&type=template&id=4dea8cad&scoped=true&"
import script from "./OActiveButton.vue?vue&type=script&lang=js&"
export * from "./OActiveButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dea8cad",
  null
  
)

export default component.exports